import React, { useCallback } from 'react';

import { NotificationManager, useLabel } from '@atlas/core';
import { Button, HeaderTitle, Icon } from '@atlas/ui';

import { NotificationEmitterBasePopup } from './NotificationEmitterBasePopup';

const MessagesPopup = ({ data = {}, id }) => {
  const { onCancel, onConfirm } = data;

  const translatedTitle = useLabel('messages_pop_up_title');
  const translatedSubtitle = useLabel('messages_pop_up_message');

  const onCloseHandler = useCallback(() => {
    if (typeof onCancel === 'function') {
      onCancel();
    }

    NotificationManager.removeNotification(id);
  }, [id, onCancel]);

  const onConfirmHandler = useCallback(() => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }

    NotificationManager.removeNotification(id);
  }, [id, onConfirm]);

  return (
    <NotificationEmitterBasePopup className="messages-popup">
      <div>
        <HeaderTitle className="messages-popup__header">
          <div className="header-title__children">
            <button onClick={onCloseHandler} type="button">
              <Icon name="close" />
            </button>
          </div>
        </HeaderTitle>

        <div className="messages-popup__content">
          <div className="icon-container">
            <Icon height={50} name="message" width={50} />
            <span className="red-dot" />
          </div>
          <p className="content-title">{translatedTitle}</p>
          <p className="content-subtitle">{translatedSubtitle}</p>
        </div>
      </div>

      <div className="messages-popup__control">
        <Button className="secondary big block" label="cancel" onClick={onCloseHandler} />
        <Button
          className="primary big block"
          label="messages_pop_up_to_messages"
          onClick={onConfirmHandler}
        />
      </div>
    </NotificationEmitterBasePopup>
  );
};

export default MessagesPopup;
